<template>
    <b-modal size="lg" id="send-mail-all" @ok="sendSmsAll" @show="initializeRecipient">

        <template #modal-title>
            <h6 class="fw-bold mb-0 akkurate-green">Send All Sms</h6>
        </template>

        <b-form-group label-for="recipient" class="mb-2" description="Number should be seperated by commas">
            <template #label>
                <div class="d-flex">
                    <b-form-radio-group v-model="selected" :options="options" @change="onRadioChange" aria-describedby="Bulk Sms" name="radio-inline"></b-form-radio-group>
                    <label class="akkurate-dark" for="recipient">Recipient <star></star></label>
                </div>
            </template>
            <!-- Account -->
             <div class="col-md-12 mb-2" v-if="selected === 'customer_type'">
                <label class="akkurate-dark small" for="priority">Customer Account type<star></star></label>
                <b-form-group id="priority" label-for="priority">
                    <multiselect class="mt-1 field-container" v-model="selectedAccountType" :options="customerAccountTypes" label="name" >
                    </multiselect>
                    <!-- <errors v-if="errors.account_type">
                        {{ errors.account_type[0] }}
                    </errors> -->
                </b-form-group>
            </div>

            <!-- Account -->
             <div class="col-md-12 mb-2" v-if="selected === 'product'">
                <label class="akkurate-dark small" for="priority">Product type<star></star></label>
                <b-form-group id="priority" label-for="priority">
                    <multiselect class="mt-1 field-container" v-model="account_type" :options="account_types" label="name" >
                    </multiselect>
                    <!-- <errors v-if="errors.account_type">
                        {{ errors.account_type[0] }}
                    </errors> -->
                </b-form-group>
            </div>

            <!-- Branch -->
            <div class="col-md-12 mb-2" v-if="selected === 'branch'">
                <label class="akkurate-dark small" for="priority">Branch<star></star></label>
                <b-form-group id="priority" label-for="priority">
                    <multiselect class="mt-1 field-container" v-model="branch" :options="branch_options" label="name" >
                    </multiselect>
                    <!-- <errors v-if="errors.account_type">
                        {{ errors.account_type[0] }}
                    </errors> -->
                </b-form-group>
            </div>

            <b-form-textarea v-if="selected == 'custom'|| selected == 'bulk'" class="mt-2 fields" id="recipient" :key="recipientKey" v-model="recipient" rows="3" max-rows="10" :disabled="disable_recipient" placeholder="Number should be seperated by commas. e.g 233054000000,233054000000"></b-form-textarea>
            <!-- <errors v-if="form.errors.message">
									{{ form.errors.message[0] }}
								</errors> -->
        </b-form-group>
        <b-form-group label-for="message" class="mb-2">
            <template #label>
                <label class="akkurate-dark" for="message">Message <star></star></label>
            </template>
            <b-form-textarea class="mt-2 fields" id="message" v-model="sms_message" rows="6" max-rows="10" placeholder="Enter Message..."></b-form-textarea>
            <div class="row text-muted small">
                <div class="col-4">
                    {{ messageCharCount }} character{{ messageCharCount !== 1 ? 's' : '' }} entered
                </div>
                <div class="col-4">
                    {{ messageCount }} message{{ messageCount !== 1 ? 's' : '' }} per recipient
                </div>
            </div>
            <div class="row text-muted small">
                <div class="col-4">
                    {{ 4 - messageCount }} message{{ (4 - messageCount) !== 1 ? 's' : '' }} left
                </div>
                <div class="col-4">
                    {{ recipientCount }} recipient{{ recipientCount !== 1 ? 's' : '' }} entered
                </div>
            </div>
            <div class="row text-muted small">
                <div class="col-4">
                    {{ messageCount * recipientCount }} total message{{ (messageCount * recipientCount)
                        !== 1 ? 's' : '' }}
                </div>
            </div>
        </b-form-group>

        <template #modal-footer="{ ok }">

            <div class="w-100">
                <!-- Emulate built in modal footer ok and cancel button actions -->
                <b-button @click="$bvModal.hide('send-mail')" type="button" class="akkurate-grey-btn border-0 btn-size ms-2 float-right"><span class="small"><font-awesome-icon class="me-2" :icon="['fas', 'close']" />Cancel
                    </span></b-button>
                <b-button @click="ok()" type="submit" :disabled="isSearching" class="akkurate-green-btn btn-size float-right border-0"><span class="small"><font-awesome-icon class="me-2" :icon="['fas', 'mail-forward']" />Forward</span></b-button>
            </div>
        </template>
    </b-modal>
</template>

<script>
// import BeatLoaderComponent from "@/views/components/Loader/BeatLoaderComponent.vue";

import ApiService from "@/core/services/api.service";
import SidebarView from "@/views/main/components/Sidebar.vue";
import TopbarView from "@/views/main/components/Topbar.vue";
import Footer from "@/views/main/components/Footer.vue";


import * as XLSX from 'xlsx';
import FileSaver from 'file-saver';
// import MemberFilter from "../forms/MemberFilter.vue";
import MemberView from '@/views/main/pages/member/view/MemberView.vue'
import 'vue-good-table/dist/vue-good-table.css';
import Multiselect from 'vue-multiselect'
import { mapActions } from "vuex";
import { type } from "jquery";
// import $ from 'jquery';
// import 'datatables.net';
// import config from '@/config.js'
// import JwtService from "@/core/services/jwt.service";

export default {
    components: {
        SidebarView,
        TopbarView,
        Footer,
        MemberView,
        Multiselect
    },
    props: {
        mobile_number: {
            type: String,
            default: "",
        }
    },
    computed: {
        // Count characters including spaces
        messageCharCount() {
            return this.sms_message ? this.sms_message.length : 0;
        },
        // Calculate how many SMS messages this will use (1 SMS = 160 chars)
        messageCount() {
            return Math.ceil(this.messageCharCount / 160) || 1;
        },
        // Calculate number of recipients (split by comma, trim, and filter out empty)
        recipientCount() {
            if (!this.recipient) return 0;
            return this.recipient
                .split(',')
                .map(num => num.trim())
                .filter(num => num.length > 0).length;
        },
    },
    data() {
        return {
            isSearching: false,
            recipientKey: 0, // Key to force re-render of recipient input
            status_option: ['Pending', 'Active', 'Inactive', "Dormant", "Closed"],
            trans_source_options: [
                { name: 'USSD', value: "ussd" },
                { name: 'OFFICE', value: "office" },
                { name: 'MOBILE', value: "mobile" },
                // { name: 'Deposit', value: "deposit" },
                // { name: 'Withdrawal', value: "withdrawal" },
            ],
            selected: 'custom',
            options: [
                { text: 'Custom', value: 'custom' },
                { text: 'Bulk', value: 'bulk' },
                { text: 'Customer Account Type', value: 'customer_type' },
                { text: 'Product', value: 'product' },
                { text: 'Branch', value: 'branch' }
            ],
            selectedAccountType: '',
            customerAccountTypes: [
                { name: 'Individual', value: 'INDIVIDUAL' },
                { name: 'Group', value: 'GROUP' },
                { name: 'Corporate', value: 'CORPORATE' }
            ],
            recipient: "",
            message: "",
            sms_message: "",
            users_options: [],
            member_id: "",
            institution: {},
            totalRecords: 0,
            searchFilter: "",
            isBusy: true,
            account_types: [],
            account_type: '',
            branch_options: [],
            branch: '',
            region_options: [],
            currentPage: 1,
            perPage: 10,
            per_page_options: ['10', '20', '50', '100', '500', '1000', '5000', '10000'],
            per_page_selected: "10",
            disable_recipient: false,
            form: {
                status: "",
                search_term: "",
                from_date: "",
                to_date: "",
                trans_source: "",
                branch: "",
                start_date: "",
                end_date: "",
                gender: "",
                gender_option: ['Male', 'Female', 'Group'],
                users: []
            },

            fields: [
                {
                    label: '#',
                    key: 'id',
                },
                {
                    label: 'Type',
                    key: 'type',
                },
                {
                    label: 'Status',
                    key: 'status',
                },
                {
                    label: 'Requested By',
                    key: 'requested_by',
                },
                {
                    label: 'Actions',
                    key: 'actions',
                },
            ],
            rows: [],
        };
    },
    mounted() {
        let token = localStorage.getItem('token');
        if (!token) {
            this.$router.push({ path: '/login' });
        }
        // this.getAccountDropdown();
        // this.loadItems();
        this.getInsistution();

        this.loadPageOptions();

    },
    methods: {
        resetFields() {
            this.selected = 'custom';
            this.selectedAccountType = '';
            this.account_type = '';
            this.branch = '';
            this.sms_message = '';
        },
        loadPageOptions() {
			this.$Progress.start();
			this.isLoading = true;
			ApiService.get("/customers/dropdown")
				.then(async (response) => {
					console.log(response.data);
					this.account_types = response.data.account_types;
					this.region_options = response.data.regions;
					this.branch_options = response.data.branches;
					// this.users_option = response.data.users;
					this.isLoading = false;
                    // $emit('coa-head-saved', response.data)
                    
                    console.log(res)
					this.$Progress.finish();
				})
				.catch((error) => {
					this.isLoading = false;
					this.$Progress.fail();
				});
        },
        validateState(ref) {
            if (
                this.veeFields[ref] &&
                (this.veeFields[ref].dirty || this.veeFields[ref].validated)
            ) {
                return !this.veeErrors.has(ref);
            }
            return null;
        },
        initializeRecipient() {
            console.log("MOBILE PROP:", this.mobile_number); // ✅ must show correct value
            if (this.mobile_number) {
                this.recipient = this.mobile_number;
            }
        },
        onRadioChange(value) {
            // Do something when a radio is selected
            if (value == 'bulk') {
                this.disable_recipient = true;
                this.recipient = "";
            } else {
                this.disable_recipient = false;
            }
        },
        async sendSmsAll() {
            if (this.selected == 'bulk') {
                this.$Progress.start();
                this.isBusy = true;
                await ApiService.post(`/sms/request/all-customers`, {
                    'message': this.sms_message,
                }).then((response) => {
                    this.$Progress.finish();
                    this.isBusy = false;
                    swal.fire({
                        // title: response.statusText,
                        text: response.data?.message,
                        icon: "success",
                        allowOutsideClick: true,
                        allowEscapeKey: true,
                        showCancelButton: false, // Show the "Cancel" button
                        confirmButtonText: "okay", // Customize the text for the "OK" button
                        buttonsStyling: false, // Disable SweetAlert2 styling for buttons
                        customClass: {
                            confirmButton:
                                "btn btn-size akkurate-green-btn modal-btn-width text-white me-2", // Custom class for the "OK" button
                        },
                    });
                    this.loadItems();
                })
                    .catch((error) => {
                        this.$Progress.fail();
                        this.isBusy = false;
                        swal.fire({
                            // title: response.statusText,
                            text: error.response.data?.message,
                            icon: "error",
                            allowOutsideClick: true,
                            allowEscapeKey: true,
                            showCancelButton: false, // Show the "Cancel" button
                            confirmButtonText: "okay", // Customize the text for the "OK" button
                            buttonsStyling: false, // Disable SweetAlert2 styling for buttons
                            customClass: {
                                confirmButton:
                                    "btn btn-size akkurate-green-btn modal-btn-width text-white me-2", // Custom class for the "OK" button
                            },
                        });
                    }).finally(() => {
                        this.$Progress.fail();
                        this.isBusy = false;
                    });

            } else if(this.selected == 'custom') {
                this.$Progress.start();
                this.isBusy = true;
                await ApiService.post(`/sms/request/multiple-phones`, {
                    'recipients': this.recipient,
                    'message': this.sms_message,
                }).then((response) => {
                    this.$Progress.finish();
                    this.isBusy = false;
                    swal.fire({
                        // title: response.statusText,
                        text: response.data?.message,
                        icon: "success",
                        allowOutsideClick: true,
                        allowEscapeKey: true,
                        showCancelButton: false, // Show the "Cancel" button
                        confirmButtonText: "okay", // Customize the text for the "OK" button
                        buttonsStyling: false, // Disable SweetAlert2 styling for buttons
                        customClass: {
                            confirmButton:
                                "btn btn-size akkurate-green-btn modal-btn-width text-white me-2", // Custom class for the "OK" button
                        },
                    });
                    this.loadItems();
                })
                    .catch((error) => {
                        this.$Progress.fail();
                        this.isBusy = false;
                        swal.fire({
                            // title: response.statusText,
                            text: error.response.data?.message,
                            icon: "error",
                            allowOutsideClick: true,
                            allowEscapeKey: true,
                            showCancelButton: false, // Show the "Cancel" button
                            confirmButtonText: "okay", // Customize the text for the "OK" button
                            buttonsStyling: false, // Disable SweetAlert2 styling for buttons
                            customClass: {
                                confirmButton:
                                    "btn btn-size akkurate-green-btn modal-btn-width text-white me-2", // Custom class for the "OK" button
                            },
                        });
                    }).finally(() => {
                        this.$Progress.fail();
                        this.isBusy = false;
                    });

            }
            else {
                console.log('message: ', this.sms_message);
                await ApiService.post(`/sms/request/send`, {
                    'type': this.selected,
                    'message': this.sms_message,
                    'selected': {
                        'selected_branch': this.branch,
                        'selected_product': this.account_type,
                        'selected_customer_type': this.selectedAccountType,
                    }
                }).then((response) => {
                    this.$Progress.finish();
                    this.isBusy = false;
                    swal.fire({
                        // title: response.statusText,
                        text: response.data?.message,
                        icon: "success",
                        allowOutsideClick: true,
                        allowEscapeKey: true,
                        showCancelButton: false, // Show the "Cancel" button
                        confirmButtonText: "okay", // Customize the text for the "OK" button
                        buttonsStyling: false, // Disable SweetAlert2 styling for buttons
                        customClass: {
                            confirmButton:
                                "btn btn-size akkurate-green-btn modal-btn-width text-white me-2", // Custom class for the "OK" button
                        },
                    });
                    this.loadItems();
                })
                    .catch((error) => {
                        this.$Progress.fail();
                        this.isBusy = false;
                        swal.fire({
                            // title: response.statusText,
                            text: error.response.data?.message,
                            icon: "error",
                            allowOutsideClick: true,
                            allowEscapeKey: true,
                            showCancelButton: false, // Show the "Cancel" button
                            confirmButtonText: "okay", // Customize the text for the "OK" button
                            buttonsStyling: false, // Disable SweetAlert2 styling for buttons
                            customClass: {
                                confirmButton:
                                    "btn btn-size akkurate-green-btn modal-btn-width text-white me-2", // Custom class for the "OK" button
                            },
                        });
                    }).finally(() => {
                        this.$Progress.fail();
                        this.isBusy = false;

                        this.resetFields()
                    });
            }

        },

        // async getAccountDropdown() {
        //     this.$Progress.start();
        //     this.isBusy = true;
        //     await ApiService.get("/accounts/create/dropdown")
        //         .then((response) => {
        //             // console.log(response);
        //             this.form.branch_option = response?.data?.branches
        //             this.form.acc_types_option = response?.data?.account_types
        //             this.users_options = response?.data?.users
        //             this.isBusy = false;
        //             this.$Progress.finish();
        //         }).catch((error) => {
        //             // console.log(error);
        //         })
        // },
        // load items is what brings back the rows from server
        // async loadItems() {
        //     this.isBusy = true;
        //     this.$Progress.start();  // Start the progress bar
        //     // console.log(this.form.users);
        //     await ApiService.post("/sms/approvals/pending",
        //         {
        //             "page": this.currentPage,
        //             "per_page": this.perPage,
        //         }
        //     ).then(response => {
        //         // Handle response and update table data
        //         this.isBusy = false;  // Set isBusy to false when the data is loaded
        //         // this.$Progress.finish();  // Finish the progress bar
        //         this.rows = response.data?.approvals;
        //         // this.totalRecords = response.data.meta.total;

        //     }).catch(() => {
        //         this.isBusy = false;  // Set isBusy to false in case of an error
        //         this.$Progress.finish();  // Finish the progress bar even if there's an error
        //         return [];  // Return an empty array in case of error to prevent the table from breaking
        //     }).finally(() => {
        //         this.isBusy = false;  // Set isBusy to false in case of an error
        //         this.$Progress.finish();  // Finish the progress bar even if there's an error
        //     });
        // },
        async getInsistution() {
            await ApiService.get("/settings/institution")
                .then((response) => {
                    // console.log(response);
                    this.institution = response.data.data;
                })
                .catch((error) => {
                    // console.log(error);
                });
        },
    },

};
</script>